import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import LayOut from "@/layouts/LayoutIndex.vue";
const routes: Array<RouteRecordRaw> = [
  {
    path: "/login",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/login/PageIndex.vue"),
  },
  {
    path: "/",
    component: LayOut,
    name: "page",
    meta: { title: "首页", icon: "HomeFilled" },
  },
  {
    path: "/ums",
    component: LayOut,
    redirect: "/ums/role",
    name: "ums",
    meta: { title: "权限", icon: "HomeFilled" },
    children: [
      {
        path: "admin",
        name: "admin",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/ums/admin/PageIndex.vue"
          ),
        meta: { title: "用户列表", icon: "ums-admin" },
      },
      {
        path: "role",
        name: "role",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/ums/role/PageIndex.vue"
          ),
        meta: { title: "角色列表", icon: "HomeFilled" },
      },
      {
        path: "allocResource",
        name: "allocResource",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/ums/role/AllocResource.vue"
          ),
        meta: { title: "分配资源", icon: "HomeFilled" },
      },
      {
        path: "menu",
        name: "menu",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/ums/menu/PageIndex.vue"
          ),
        meta: { title: "菜单列表", icon: "ums-menu" },
      },
      {
        path: "resource",
        name: "resource",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/ums/resource/PageIndex.vue"
          ),
        meta: { title: "资源列表", icon: "HomeFilled" },
      },
      {
        path: "resourceCategory",
        name: "resourceCategory",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/ums/resourceCategory/PageIndex.vue"
          ),
        meta: { title: "资源分类", icon: "HomeFilled" },
      },
      {
        path: "test",
        name: "test",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/ums/test/PageIndex.vue"
          ),
        meta: { title: "test", icon: "HomeFilled" },
      },
    ],
  },
  {
    path: "/config",
    component: LayOut,
    redirect: "/config/currency",
    name: "config",
    meta: { title: "币种列表", icon: "HomeFilled" },
    children: [
      {
        path: "currency",
        name: "currency",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/config/currency/CurrencyIndex.vue"
          ),
        meta: { title: "币种列表", icon: "ums-admin" },
      },
      {
        path: "card",
        name: "card",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/config/card/CardIndex.vue"
          ),
        meta: { title: "卡种列表", icon: "ums-admin" },
      },
      {
        path: "rate",
        name: "rate",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/config/rate/RateIndex.vue"
          ),
        meta: { title: "汇率列表", icon: "ums-admin" },
      },
      {
        path: "dict",
        name: "dict",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/config/dict/DictIndex.vue"
          ),
        meta: { title: "字典列表", icon: "ums-admin" },
      },
      {
        path: "cardPriceControl",
        name: "cardPriceControl",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/config/cardPriceControl/cardPriceControlIndex.vue"
          ),
        meta: { title: "卡价控列表", icon: "ums-admin" },
      },
    ],
  },
  {
    path: "/mms",
    component: LayOut,
    redirect: "/mms/member",
    name: "mms",
    meta: { title: "会员管理" },
    children: [
      {
        path: "member",
        name: "member",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/mms/member/MemberIndex.vue"
          ),
        meta: { title: "会员列表", icon: "ums-admin" },
      },
      {
        path: "server",
        name: "server",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/mms/server/ServerIndex.vue"
          ),
        meta: { title: "服务商列表", icon: "ums-admin" },
      },
    ],
  },
  {
    path: "/fms",
    component: LayOut,
    redirect: "/fms/accountList",
    name: "fms",
    meta: { title: "财务管理" },
    children: [
      {
        path: "accountList",
        name: "accountList",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/fms/accountList/PageIndex.vue"
          ),
        meta: { title: "账号列表", icon: "ums-admin" },
      },
      // {
      //   path: 'server',
      //   name: 'server',
      //   component: () =>
      //     import(
      //       /* webpackChunkName: "about" */ '../views/mms/server/ServerIndex.vue'
      //     ),
      //   meta: { title: '服务商列表', icon: 'ums-admin' },
      // },
    ],
  },
  {
    path: "/sms",
    component: LayOut,
    redirect: "/sms/transfer",
    name: "sms",
    meta: { title: "统计管理" },
    children: [
      {
        path: "transfer",
        name: "transfer",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/sms/transfer/PageIndex.vue"
          ),
        meta: { title: "转账", icon: "ums-admin" },
      },
      {
        path: "jour",
        name: "jour",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/sms/jour/PageIndex.vue"
          ),
        meta: { title: "积分", icon: "ums-admin" },
      },
    ],
  },
  {
    path: "/dms",
    component: LayOut,
    redirect: "/dms/tradeVolume",
    name: "dms",
    meta: { title: "数据看板" },
    children: [
      {
        path: "tradeVolume",
        name: "tradeVolume",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/dms/tradeVolume/index.vue"
          ),
        meta: { title: "数据看板", icon: "AreaChartOutlined" },
      },
      {
        path: "serverTradeVolume",
        name: "serverTradeVolume",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/dms/serverTradeVolume/index.vue"
          ),
        meta: { title: "礼品卡订单统计", icon: "AreaChartOutlined" },
      },
      {
        path: "withdrawVolume",
        name: "withdrawVolume",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/dms/withdrawVolume/index.vue"
          ),
        meta: { title: "提现订单统计", icon: "AreaChartOutlined" },
      },
      {
        path: "buyerHistoryOrder",
        name: "buyerHistoryOrder",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/dms/buyerHistoryOrder/PageIndex.vue"
          ),
        meta: { title: "礼品卡历史订单统计", icon: "AreaChartOutlined" },
      },
      {
        path: "withdrawHistoryOrder",
        name: "withdrawHistoryOrder",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/dms/withdrawHistoryOrder/PageIndex.vue"
          ),
        meta: { title: "提现历史订单统计", icon: "AreaChartOutlined" },
      },
      {
        path: "notWithdrawAmount",
        name: "notWithdrawAmount",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/dms/notWithdrawAmount/index.vue"
          ),
        meta: { title: "未提现积分数量", icon: "AreaChartOutlined" },
      },
    ],
  },
  {
    path: "/cms",
    component: LayOut,
    redirect: "/cms/ServerChat",
    name: "cms",
    meta: { title: "聊天管理" },
    children: [
      {
        path: "ServerChat",
        name: "ServerChat",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/cms/ServerChat/PageIndex.vue"
          ),
        meta: { title: "服务商聊天", icon: "ums-admin" },
      },
    ],
  },
  {
    path: "/coupon",
    name: "coupon",
    component: LayOut,
    redirect: "/coupon/couponTemplate",
    meta: { title: "优惠券管理" },
    children: [
      {
        path: "couponTemplate",
        name: "couponTemplate",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/couponms/couponTemplate/PageIndex.vue"
          ),
        meta: { title: "优惠券模板", icon: "ums-admin" },
      },
      {
        path: "couponApplication",
        name: "couponApplication",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/couponms/couponAppliaction/PageIndex.vue"
          ),
        meta: { title: "券申请管理", icon: "ums-admin" },
      },
      {
        path: "eligibleCoupons",
        name: "eligibleCoupons",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/couponms/eligibleCoupons/PageIndex.vue"
          ),
        meta: { title: "符合条件的券", icon: "ums-admin" },
      },
      {
        path: "issuedCoupons",
        name: "issuedCoupons",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/couponms/issuedCoupons/PageIndex.vue"
          ),
        meta: { title: "已发放的券", icon: "ums-admin" },
      },
      {
        path: "usedCoupons",
        name: "usedCoupons",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/couponms/usedCoupons/PageIndex.vue"
          ),
        meta: { title: "已使用的券", icon: "ums-admin" },
      },
      {
        path: "unusedCoupons",
        name: "unusedCoupons",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/couponms/unusedCoupons/PageIndex.vue"
          ),
        meta: { title: "未使用的券", icon: "ums-admin" },
      },
      
    ],
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
